module.exports = __webpack_public_path__ + "static/media/avatar.cc93a967.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/avatar.jpg
// module id = 98
// module chunks = 0